import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { connect } from '../../../../react-redux';
import ItemEdit from './presenter';
import makeEditable from '../../../shared/functionality/makeEditable';
import { openModal } from '../../../../actions/modal';
import { occludeQuizEntries } from '../../../../actions/ui';
import { generateImportModalId } from '../../../../../common/components/ImportModal';
import { showError, hideError } from '../../../../actions/errorsShowing';
import { uploadStatus as setUploadStatus } from '../../../../actions/upload';
import * as modificationActions from '../../../../actions/modifications';
import { addError, screenreaderNotification } from '../../../../actions/alerts';
import { updateItem } from '../../../../../building/api/items';
import { interactionFileUpload, setOneAtATimeType } from '../../../../../building/api/quizzes';
import { featureOn } from '../../../../util/featureCheck';
import { getActiveQuizId, isActiveQuizWorkingInstanceOneQuestionAtATime } from '../../../../../common/selectors/quizzes';
export function mapStateToProps(state, props) {
  // Error Related:
  var workingItem = props.entry.getWorkingInstance();
  var isValid = workingItem.isValid();
  var errorsShowing = state.get('errorsShowing', Map());
  var errorsAreShowing = errorsShowing.get(props.guid);
  // Null must always be passed to contextUuid when working with banks
  var contextUuid = props.contextUuid === void 0 ? state.getIn(['outcomes', 'contextUuid']) : props.contextUuid;
  return {
    answerFeedbackEnabled: featureOn('answer_level_feedback'),
    appContainer: state.getIn(['ui', 'appContainer']),
    errorsAreShowing: errorsAreShowing,
    workingItem: workingItem,
    isValid: isValid,
    isEditing: true,
    fitbCommonWordbankEnabled: featureOn('fitb_common_wordbank'),
    editable: true,
    contextUuid: contextUuid,
    oneQuestionAtATime: isActiveQuizWorkingInstanceOneQuestionAtATime(state),
    outcomesEndpoint: state.getIn(['outcomes', 'outcomesEndpoint']),
    outcomesToken: state.getIn(['outcomes', 'outcomesToken']),
    partialDeepScoringEnabled: featureOn('partial_deep_scoring'),
    partialScoringEnabled: featureOn('partial_scoring'),
    quizId: getActiveQuizId(state),
    scope: props.scope,
    rootAccountUuid: state.getIn(['outcomes', 'externalAccountUuid'])
  };
}
function mapDispatchToProps(dispatch) {
  return {
    addError: bindActionCreators(addError, dispatch),
    changeItemState: bindActionCreators(modificationActions.changeItemState, dispatch),
    changeOutcomeAlignmentSetGuid: bindActionCreators(modificationActions.changeOutcomeAlignmentSetGuid, dispatch),
    hideError: bindActionCreators(hideError, dispatch),
    interactionFileUpload: bindActionCreators(interactionFileUpload, dispatch),
    occludeQuizEntries: bindActionCreators(occludeQuizEntries, dispatch),
    showError: bindActionCreators(showError, dispatch),
    updateItem: bindActionCreators(updateItem, dispatch),
    screenreaderNotification: bindActionCreators(screenreaderNotification, dispatch),
    setOneQuestionAtATime: bindActionCreators(setOneAtATimeType, dispatch),
    setUploadStatus: bindActionCreators(setUploadStatus, dispatch),
    openImportModal: function openImportModal(importModalId) {
      dispatch(openModal(generateImportModalId(importModalId)));
    }
  };
}
export default makeEditable(connect(mapStateToProps, mapDispatchToProps)(ItemEdit));